/**
 * Preview Setup Module
 * Responsible for validating preview and setting up event listeners for capturing client events.
 * @module
 */
var _ = require('optimizely-client-fn');
var di = require('core/di');
var EventEmitter = require('core/event_emitter');
var EventEmitterEnums = require('core/constants/event_emitter');
var WindowEnv = require('core/env/window');
var DirectiveStore = di.get('stores/directive');

var PREVIEW_EVENT_LOG_GLOBAL = 'optimizelyPreview';

var pushOnLog = function(event) {
  // wrap in anonymous function to always get current reference to window[PREVIEW_EVENT_LOG_GLOBAL]
  var log = WindowEnv.getGlobal(PREVIEW_EVENT_LOG_GLOBAL);
  log.push(event);
};

/**
 * Ensure that the preview projectId matches the projectId of the bootstrap client
 * preview (for standalone mode).
 * @param projectId
 */
function validatePreview(projectId) {
  var previewValidated = false;

  // Loop through the global array and look for a verifyPreviewProject entry.
  if (_.isArray(__GLOBAL__)) {
    _.each(__GLOBAL__, function(apiCall) {
      if (_.isArray(apiCall) && apiCall[0] === 'verifyPreviewProject') {
        if (String(apiCall[1]) === projectId) {
          previewValidated = true;
        }
      }
    });
  }

  if (!previewValidated) {
    throw new Error('Preview projectId: ' + projectId + ' does not match expected');
  }
}

/**
 * Setup event listeners for specific analytics events like layer decisions and events
 * This should only be called once as it adds event listeners.
 */
function setupPreviewEventLog() {
  EventEmitter.on({
    filter: {
      type: EventEmitterEnums.TYPES.ANALYTICS,
      name: 'trackEvent',
    },
    handler: pushOnLog,
  });

  EventEmitter.on({
    filter: {
      type: EventEmitterEnums.TYPES.LIFECYCLE,
      name: 'viewActivated',
    },
    handler: pushOnLog,
  });

  EventEmitter.on({
    filter: {
      type: EventEmitterEnums.TYPES.LIFECYCLE,
      name: 'layerDecided',
    },
    handler: pushOnLog,
  });

  EventEmitter.on({
    filter: {
      type: 'error',
    },
    // Only listen to "public" error events
    publicOnly: true,
    handler: pushOnLog,
  });
}

/**
 * Initialize preview by validating the project ID and setting up the event log handler.
 * @param projectId
 */
exports.initialize = function(projectId) {
  if (DirectiveStore.isSlave()) {
    validatePreview(projectId);
  }
  setupPreviewEventLog();
};

/**
 * Ensure the preview global object is defined.
 */
exports.setupPreviewGlobal = function() {
  if (!WindowEnv.getGlobal(PREVIEW_EVENT_LOG_GLOBAL)) {
    WindowEnv.setGlobal(PREVIEW_EVENT_LOG_GLOBAL, []);
  }
};

/**
 * Push the provided event into the preview global object.
 * @param event
 */
exports.pushToPreviewGlobal = function(event) {
  pushOnLog(event);
};

if (__TEST__) {
  exports.validatePreview = validatePreview;
  exports.setupPreviewEventLog = setupPreviewEventLog;
}
